export default __webpack_public_path__ + "static/media/plan-hospitals.ebdd776c.png";